import { generateJsxKey } from '@utils/ast';
import { SplitComponent } from './_split-component.js';
import { jsx } from 'react/jsx-runtime';

const printSplitComponent = (node, context) => {
  return /*#__PURE__*/jsx(SplitComponent, {
    node: node
  }, generateJsxKey(context));
};
const splitComponentJsxPrinters = {
  "split-component": printSplitComponent
};

export { printSplitComponent, splitComponentJsxPrinters };
//# sourceMappingURL=printer.to-jsx.js.map
